// src/portals/fan/pages/NotificationsPage/components/NotificationItem.js
import React from 'react';
import { Video, MessageSquare, Repeat, Heart } from 'lucide-react';

const NotificationItem = ({ notification }) => {
  const getIconForType = (type) => {
    switch (type) {
      case 'new_post':
        return <Video className="w-5 h-5 text-white" />;
      case 'message':
        return <MessageSquare className="w-5 h-5 text-white" />;
      case 'subscription':
        return <Repeat className="w-5 h-5 text-white" />;
      case 'tip_thanks':
        return <Heart className="w-5 h-5 text-white" />;
      default:
        return null;
    }
  };

  const getIconBgColor = (type) => {
    switch (type) {
      case 'new_post': return 'bg-red-500';
      case 'message': return 'bg-blue-500';
      case 'subscription': return 'bg-green-500';
      case 'tip_thanks': return 'bg-pink-500';
      default: return 'bg-slate-500';
    }
  };

  return (
    <div className={`flex items-start p-4 space-x-4 ${!notification.isRead ? 'bg-primary/5' : ''}`}>
      <div className={`w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center ${getIconBgColor(notification.type)}`}>
        {getIconForType(notification.type)}
      </div>
      <div className="flex-grow">
        <p className="text-sm text-slate-700">
          <span className="font-bold text-slate-800">{notification.creatorName}</span>{' '}
          {notification.text}
        </p>
        <p className="text-xs text-slate-500 mt-1">{notification.timestamp}</p>
      </div>
      {!notification.isRead && (
        <div className="w-2.5 h-2.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
      )}
    </div>
  );
};

export default NotificationItem;